'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var Dialog = _interopDefault(require('@material-ui/core/Dialog'));

var StyledDialog = styled__default(Dialog)(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  border-radius: 6px;\n  box-shadow: 0 11px 15px 8px rgba(0, 0, 0, 0.12);\n"], ["\n  border-radius: 6px;\n  box-shadow: 0 11px 15px 8px rgba(0, 0, 0, 0.12);\n"])));
// eslint-disable-next-line import/prefer-default-export
var SC = { Dialog: StyledDialog };
var templateObject_1;

module.exports = SC;
